const equalKeys = (keys: readonly (string | number)[], path: readonly (string | RegExp)[]) => {
  if (keys.length !== path.length) {
    return false
  }

  return keys.every((key, i) => {
    const current = path[i]
    return current instanceof RegExp ? current.test(key.toString()) : key.toString() === current
  })
}

/**
 * reviverのインターフェースは以下のプロポーザルに合わせています。
 * @see https://github.com/tc39/proposal-json-parse-with-source
 */
export type Reviver = (key: string, value: unknown, context: { keys: readonly (string | number)[] }) => unknown

const createReviver = (
  ...deserializers: {
    path: readonly (string | RegExp)[]
    deserialize: (value: unknown) => unknown
  }[]
): Reviver => {
  return (_, value, { keys }) => {
    for (const { path, deserialize } of deserializers) {
      if (equalKeys(keys, path)) {
        return deserialize(value)
      }
    }

    return value
  }
}

export default createReviver
